import React, { FC, useState } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/AnnualConference/components/Video/Video.module.scss';

const cn = classNames.bind(styles);

interface IVideo {
  image: string;
  video: string;
}

const Video: FC<IVideo> = ({ image, video }): React.ReactElement => {
  const [videoShow, setVideoShow] = useState<boolean>(false);

  const videoPlay = () => {
    const video = document.querySelector<HTMLVideoElement>('#video-player');
    setVideoShow(true);
    video!.play();
  };

  const videoCloset = (event: React.MouseEvent) => {
    const video = document.querySelector<HTMLVideoElement>('#video-player');

    if (event.target === video) return;

    setVideoShow(false)
    video!.pause();
  };

  return (
    <div className={cn('video-player')}>
      <div onClick={videoPlay} className={cn('video-player__video-box')}>
        <div className={cn('video-player__video-preview-box')}>
          <img
            className={cn('video-player__video-preview')}
            style={videoShow ? { opacity: 0 } : { opacity: 1 }}
            src={image} alt="video"
          />
          <svg className={cn('play-button')} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle className={cn('play-button__circle')} cx="40" cy="40" r="30" fill="none" />
            <path className={cn('play-button__triangle')} d="M35.838 29.795L50.8636 38.5599C51.9661 39.203 51.9661 40.796 50.8636 41.4392L35.838 50.2041C34.7269 50.8523 33.3315 50.0508 33.3315 48.7645V31.2346C33.3315 29.9483 34.7269 29.1468 35.838 29.795Z" fill="none" />
          </svg>
        </div>
      </div>
      <div
        onClick={(event: React.MouseEvent<HTMLDivElement>) => videoCloset(event)}
        className={cn('video-player__video-wrapper', { 'video-player__video-wrapper-active': videoShow })}>
        <div className={cn('video-player__video-closet')} />
        <video className={cn('video-player__video')} id="video-player" controls>
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export { Video };
